import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IGroundCardLinkProps } from "./GroundCardLink.props";

export const GroundCardLink = ({ children, className, link }: IGroundCardLinkProps) => {
  const classes = cn(
    "group block border-t border-weathered-steel bg-transparent transition-[background-color,border-color] duration-200 ease-out",
    link &&
      "hover:border-primary hover:bg-surface-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    className,
  );

  if (!link) return <article className={classes}>{children}</article>;

  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};

GroundCardLink.displayName = "Content::GroundCardLink";
